import { useMemo } from 'react';

export default function useErrorField(fieldError: string | undefined, isTouched: boolean) {
  return useMemo(() => {
    return fieldError && isTouched ? { error: true, helperText: fieldError } : {};
  }, [fieldError, isTouched]);
}
